import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const SportContext = createContext<{
  params?: Routing.SportParams
}>({})

export { SportContext }
